export default (that) => [
  {
    field: "seq",
    minWidth: 40,
    align: "center",
    type: "seq",
  },
  {
    field: "checkbox",
    minWidth: 40,
    align: "center",
    type: "checkbox",
  },
  {
    type: "expand",
    minWidth: 50,
    align: "center",
    title: that.$l("INDEX.form_label_expand") || "展开",
    slots: {
      content: "expandContent",
    },
    showHeaderOverflow: true,
  },
  {
    field: "col-opt",
    title: that.$l("INDEX.table_label_operation") || "操作",
    headerAlign: "center",
    align: "center",
    width: 90,
    slots: {
      default: "opt",
    },
  },

  {
    title: that.$l("table_label_package_no") || "包装编号",
    field: "packageNo",
    headerAlign: "center",
    align: "center",
    minWidth: 160,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("form_label_package_name") || "包装名称",
    field: "packageName",
    headerAlign: "center",
    align: "center",
    minWidth: 160,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("form_label_package_specification") || "包装规格",
    field: "packageDesc",
    headerAlign: "center",
    align: "center",
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_price") ||"单价",
    field: "unitPrice",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_qty") ||"数量",
    field: "qty",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.order_goods_label_subAmount")||"小计金额",
    field: "subAmount",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_factory_package_number')||"工厂包装编号",
    field: "factoryNumber",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_remarks')||"备注",
    field: "remark",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
